// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-routes-App-components-Offline-offline__indicator--3du_t{height:32px;background:#00A043;color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;padding:8px 0;position:absolute;width:100%;bottom:-32px;z-index:502;transition:transform 0.2s ease-in-out 1s, background 0.3s}.src-routes-App-components-Offline-offline__offline--1mo8B{background:#2980b9;transform:translate3d(0, -32px, 0)}@media screen and (min-width: 1024px){.src-routes-App-components-Offline-offline__indicator--3du_t{bottom:-32px;left:0}}\n", ""]);
// Exports
exports.locals = {
	"indicator": "src-routes-App-components-Offline-offline__indicator--3du_t",
	"offline": "src-routes-App-components-Offline-offline__offline--1mo8B"
};
module.exports = exports;
